/**
 * @file 跳转到客户端登录页
 * @author lixin01
 */
define(function (require, exports, module) {
    'use strict'

    var store = require('../store')
    var urlQuery = require('cobble/util/url').parseQuery(location.search)
    var extension = require('../../classroom/extension/cef')
    var inClient = require('../../classroom/function/inClient')

    return function () {
        var backUrl
        if (BJY.is.inElectronClient()) {
            // 旧版本客户端 backToEntry 方法可能有问题
            if (window.ClientBridge && window.ClientBridge.backToEntry
                && BJY.checkVersion && BJY.checkVersion('1.5.2', ClientBridge.version)) {
                window.ClientBridge.backToEntry()
                return
            }
            window.location.href =  window.location.origin + '/entry/' + store.get('partner.partnerId', '')
        }
        else {
            cefQuery({
                request: JSON.stringify({
                    funcName: 'RunCNE',
                    params: ''
                }),
                persistent: false,
                onSuccess: function (json) {
                    // json = JSON.parse(json);
                    cefQuery({
                        request: JSON.stringify({
                            funcName: 'GetClientLoginPage',
                            params: ''
                        }),
                        persistent: false,
                        onSuccess: function (json) {
                            var data = JSON.parse(json).data
                            // 从 cef 取定制版客户端登录页 url
                            if (inClient()) {
                                backUrl = data.login_page
                                    ? data.login_page
                                    : store.get('partner.partnerId')
                                        ? window.location.origin + '/entry/' + store.get('partner.partnerId')
                                        : '/web/room/clientlogin'

                                window.location.href = backUrl
                            }
                        }
                    })
                },
                onFailure: function (errorCode, errorMsg) {}
            })  
        }
    }
})
